import React, { useContext } from 'react';
import { AuthContext } from '../../../../../../contexts/AuthContext';
import { formatMoney, formatNumber } from '../../../../../../utils/utils';
import ButtonTableAction from '../../../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../../../components/default/DefaultDataTable';
import { WarehouseHistoryDataForm, WarehouseQuoteHistory, WarehouseQuoteHistoryFilters } from '../../../../../../app/models/WareHouseQuoteHistory';
import { momentParseDate } from '../../../../../../helpers';

interface Props {
    warehouseQuoteHistory: WarehouseQuoteHistory[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    show?: (id: number) => void;
    filter: WarehouseQuoteHistoryFilters;
    setFilter: (filter: WarehouseQuoteHistoryFilters) => void;
    paginationRowsPerPageOptions?: any[];
}

const WarehouseHistoryDataTable = ({
    warehouseQuoteHistory,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter
}: Props) => {
    const { auth } = useContext(AuthContext);

    const columns = [



        {
            name: 'ID',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: WarehouseHistoryDataForm, index: any, column: any) => (
                <span className="">{row.id}</span>

            //     <span className="">
            //     <div
            //         dangerouslySetInnerHTML={{
            //             __html: row.depot ? String(row.depot) : ''
            //         }}
            //     />
            // </span>

            )
        },

        {
            name: 'Descripcion',
            selector: (row: any) => row.description,
            sortable: true,
            sortField: 'description',
            cell: (row: WarehouseHistoryDataForm) => (
                <span className="">{row.description}</span>
            )
        },

        {
            name: 'Creado por',
            selector: (row: any) => row.created_user?.username,
            sortable: true,
            sortField: 'created_user',
            cell: (row: WarehouseHistoryDataForm) => (
                <span className="">
                <div
                    dangerouslySetInnerHTML={{
                    __html: row.created_user ? String(row.created_user) : ''               

                }}
                />
            </span>
            )
        },

        {
            name: 'Fecha de Cambio',
            selector: (row: any) => row.created_at,
            sortable: true,
            sortField: 'created_at',
            cell: (row: WarehouseHistoryDataForm) => (
                <span className="">{momentParseDate(row.created_at)}</span>
            )
        },
        // {
        //     name: 'Acciones',
        //     cell: (row: any) => (
        //         <div className="d-flex gap-1">
        //             {show && (
        //                 <ButtonTableAction
        //                     callbackFunction={() => show(row.id ?? -1)}
        //                     classIcon="mdi mdi-eye"
        //                     colorIcon="text-info"
        //                     title="Ver"
        //                 />
        //             )}
        //         </div>
        //     )
        // }
    ];

    return (
        <div className="row">
            <div className="col-12 mt-4">
                <DefaultDataTable
                    columns={columns}
                    data={warehouseQuoteHistory}
                    progressPending={loading}
                    filter={filter}
                    setFilter={setFilter}
                    paginationTotalRows={totalRows}
                />
            </div>
        </div>
    );
};

export default WarehouseHistoryDataTable;
